import type { ApiResponse } from '@/types/api-response.types'
import type { OnlineCourse } from '@/types/online-course.types'
import api from '../axios'

export const onlineCourseService = {
  async getOnlineCourses(): Promise<OnlineCourse[]> {
    const response: ApiResponse<OnlineCourse[]> = await api.get('/v1/online-course',)
    return response.body
  },

  async toggleNotification(idx: number): Promise<boolean> {
    const response: ApiResponse<boolean> = await api.post(`/v1/online-course/${idx}/notification`)
    return response.body
  },
}
